module.exports = __webpack_public_path__ + "static/media/closeIcon.beee0f54.svg";